import React from 'react';
// Remova o useNavigate, não vamos mais usar aqui
import * as Style from './GoToPaymentStyle';

// Adicione a nova prop 'onPayNow'
const GoToPayment = ({ onClose, onPayNow }) => {

  const handlePayNow = () => {
    onPayNow(); // Chama a função para abrir o próximo modal
  };

  const handlePayLater = () => {
    onClose();
  };

  return (
    <Style.ModalContainer>
      <Style.ModalBox>
        <Style.Title>Contrato Gerado com Sucesso!</Style.Title>
        <Style.Message>
          Seu contrato foi registrado e está pendente de pagamento. Você pode efetuar o pagamento agora ou mais tarde na sua lista de contratos.
        </Style.Message>
        <Style.ButtonContainer>
          <Style.ActionButton onClick={handlePayNow}>
            Pagar Agora
          </Style.ActionButton>
          <Style.SecondaryButton onClick={handlePayLater}>
            Pagar Depois
          </Style.SecondaryButton>
        </Style.ButtonContainer>
      </Style.ModalBox>
    </Style.ModalContainer>
  );
};

export default GoToPayment;